// extracted by mini-css-extract-plugin
export default {"fullWidth":"Tm-z","image":"Um-z","lazyLoadPicture":"Vm-z","lazyLoadSpinner":"Wm-z","lazyLoadSpin":"Xm-z","lazyLoadImage":"Ym-z","hasStyledAspectRatio":"Zm-z"};